<template>
  <div class="modal fade" :id="''+id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('access.card.change_status')}}</h5> <!-- Changé le titre -->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <Select2
                :parent-id="'#'+id"
                containerClass="col-12 mb-5"
                :name="'status'+id"
                :multiple="false"
                :label="$t('access.card.status')"
                labelClass="mb-3"
                selectClass="form-select form-select-solid"
                :isRequired="true"
                :placeholderText="$t('access.card.select_status_placeholder')"
                v-model="formData.status"
                :IsInputGroup="false"
            >
              <option v-for="status in filteredStatuses" :key="status.value" :value="status.value">
                {{ status[i18n.global.locale.value] || status.fr }}
              </option>
            </Select2>

          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineProps, computed, onMounted, watch} from 'vue'
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import Select2 from "@/components/Select2.vue";
import i18n from "@/plugins/i18n";


const store = useStore()

const props = defineProps({
  form: {
    type: Object,
    default: {
      id: '',
      status: '',
    }
  },
  id: {
    type: String,
    required: true
  },
})

const emits = defineEmits(['load'])


const formData = ref(props.form)
const isLoading = ref(false)

const filteredStatuses = computed(() => {
  const allStatuses = store.getters['cards/getCardStatus'] || [];
  const allowedStatuses = ['available', 'lost', 'blocked'];

  return allStatuses.filter(status => allowedStatuses.includes(status.value));
});

watch(() => props.form, (value) => {
  formData.value = {...props.form};
}, { deep: true });

function submitData(){
  isLoading.value = true;
  let message = 'notification.cards_status_updated';

  store.dispatch('cards/changeStatus', {
    id: formData.value.id,
    data: {
      status: formData.value.status
    }
  })
      .then((response) => {
        emits('load');
        isLoading.value = false;
        closeModal();
        formData.value = {
          id: '',
          status: '',
        };
        window.toastr['success'](i18n.global.t(message));
      })
      .catch(err => {
        isLoading.value = false;
      });
}

function closeModal(){
  $('#'+props.id).modal('hide');
  formData.value = {
    id: '',
    status: '',
  };
}
</script>